import React from "react";
import firebase, { institutesRef, db } from "./firebaseconn";
import { Row, Col } from "react-bootstrap";

export const getReviewByInstituteAndUser = async function (
  instituteID,
  userEmail
) {
  try {
    const snapshot = await institutesRef
      .doc(instituteID)
      .collection("reviews")
      .where("userEmail", "==", userEmail)
      .get();

    const relevantReview = snapshot.docs.filter(
      (review) => review.data().relevant === true
    );
    const review = relevantReview.map((review) => {
      const {
        active,
        relevant,
        createdAt,
        updatedAt,
        userEmail,
        userName,
        text,
        ...rest
      } = review.data();

      return rest;
    });
    return review[0];
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

export const getReviewsByInstitute = async function (instituteID) {
  try {
    const snapshot = await institutesRef
      .doc(instituteID)
      .collection("reviews")
      .orderBy("createdAt", "desc")
      .get();

    const activeReviews = snapshot.docs.filter(
      (review) => review.data().active === true
    );

    return activeReviews.map((review) => ({
      id: review.id,
      ...review.data(),
    }));
    // return []; in case you don't want to show the individual reviews
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

const initReviewAvgs = function () {
  return {
    administrationQuality: {
      total: 0,
      n: 0,
    },
    diplomaTime: {
      total: 0,
      n: 0,
    },
    facilitiesHigiene: {
      total: 0,
      n: 0,
    },
    facilitiesQuality: {
      total: 0,
      n: 0,
    },
    graduationTime: {
      total: 0,
      n: 0,
    },
    professorsEthics: {
      total: 0,
      n: 0,
    },
    professorsQuality: {
      total: 0,
      n: 0,
    },
    programQuality: {
      total: 0,
      n: 0,
    },
    security: {
      total: 0,
      n: 0,
    },
    tutorQuality: {
      total: 0,
      n: 0,
    },
    tuition: {
      total: 0,
      n: 0,
    },
    allowsSeeingExams: {
      yes: 0,
      no: 0,
      mol: 0,
      idk: 0,
    },
    hasAC: {
      yes: 0,
      no: 0,
      mol: 0,
      idk: 0,
    },
    hasInternet: {
      yes: 0,
      no: 0,
      mol: 0,
      idk: 0,
    },
    hasRunningWater: {
      yes: 0,
      no: 0,
      mol: 0,
      idk: 0,
    },
    hasCorruption: {
      yes: 0,
      no: 0,
    },
    hasSexualHarassment: {
      yes: 0,
      no: 0,
    },
    hasInternship: {
      yes: 0,
      no: 0,
    },
    endorsement: {
      yes: 0,
      no: 0,
    },
  };
};

const getNewReviewAvg = function (oldReviewAvgs, data, i, v) {
  return {
    total: oldReviewAvgs[v].total + i * data[v],
    n: data[v] ? oldReviewAvgs[v].n + i : oldReviewAvgs[v].n,
  };
};

const genNewReviewAvgs = function (oldReviewAvgs, data, i) {
  if (!oldReviewAvgs) oldReviewAvgs = initReviewAvgs();

  return {
    administrationQuality: getNewReviewAvg(
      oldReviewAvgs,
      data,
      i,
      "administrationQuality"
    ),
    diplomaTime: getNewReviewAvg(oldReviewAvgs, data, i, "diplomaTime"),
    facilitiesHigiene: getNewReviewAvg(
      oldReviewAvgs,
      data,
      i,
      "facilitiesHigiene"
    ),
    facilitiesQuality: getNewReviewAvg(
      oldReviewAvgs,
      data,
      i,
      "facilitiesQuality"
    ),
    graduationTime: getNewReviewAvg(oldReviewAvgs, data, i, "graduationTime"),
    professorsEthics: getNewReviewAvg(
      oldReviewAvgs,
      data,
      i,
      "professorsEthics"
    ),
    professorsQuality: getNewReviewAvg(
      oldReviewAvgs,
      data,
      i,
      "professorsQuality"
    ),
    programQuality: getNewReviewAvg(oldReviewAvgs, data, i, "programQuality"),
    security: getNewReviewAvg(oldReviewAvgs, data, i, "security"),
    tutorQuality: getNewReviewAvg(oldReviewAvgs, data, i, "tutorQuality"),
    tuition: getNewReviewAvg(oldReviewAvgs, data, i, "tuition"),
    allowsSeeingExams: {
      ...oldReviewAvgs.allowsSeeingExams,
      [data.allowsSeeingExams]:
        oldReviewAvgs.allowsSeeingExams[data.allowsSeeingExams] + i,
    },
    endorsement: {
      ...oldReviewAvgs.endorsement,
      [data.endorsement]: oldReviewAvgs.endorsement[data.endorsement] + i,
    },
    hasInternship: {
      ...oldReviewAvgs.hasInternship,
      [data.hasInternship]: oldReviewAvgs.hasInternship[data.hasInternship] + i,
    },
    hasAC: {
      ...oldReviewAvgs.hasAC,
      [data.hasAC]: oldReviewAvgs.hasAC[data.hasAC] + i,
    },
    hasCorruption: {
      ...oldReviewAvgs.hasCorruption,
      [data.hasCorruption]: oldReviewAvgs.hasCorruption[data.hasCorruption] + i,
    },
    hasInternet: {
      ...oldReviewAvgs.hasInternet,
      [data.hasInternet]: oldReviewAvgs.hasInternet[data.hasInternet] + i,
    },
    hasRunningWater: {
      ...oldReviewAvgs.hasRunningWater,
      [data.hasRunningWater]:
        oldReviewAvgs.hasRunningWater[data.hasRunningWater] + i,
    },
    hasSexualHarassment: {
      ...oldReviewAvgs.hasSexualHarassment,
      [data.hasSexualHarassment]:
        oldReviewAvgs.hasSexualHarassment[data.hasSexualHarassment] + i,
    },
  };
};

export const createReview = async function (data, instituteID, currentUser) {
  data.createdAt = firebase.firestore.FieldValue.serverTimestamp();
  data.updatedAt = firebase.firestore.FieldValue.serverTimestamp();
  data.userEmail = currentUser.email;
  // data.instituteID = institute.id;
  data.userName = currentUser.userName;
  data.active = true;
  data.relevant = true;

  try {
    const snapshot = await institutesRef
      .doc(instituteID)
      .collection("reviews")
      .where("userEmail", "==", currentUser.email)
      .get();

    const relevantOldReviews = snapshot.docs.filter(
      (review) => review.data().relevant === true
    );

    const oldReviews = relevantOldReviews.map((review) => {
      return { id: review.id, ...review.data() };
    });

    await db.runTransaction(async (t) => {
      const institute = await t.get(institutesRef.doc(instituteID));

      const newReviewRef = await institutesRef
        .doc(instituteID)
        .collection("reviews")
        .doc();

      await t.set(newReviewRef, data);

      const oldReviewAvgs = institute.data().reviewAvgs;
      let newReviewAvgs = {};

      const oldReview = oldReviews[0];

      if (oldReview) {
        await t.update(
          institutesRef
            .doc(instituteID)
            .collection("reviews")
            .doc(oldReview.id),
          { relevant: false }
        );
        newReviewAvgs = genNewReviewAvgs(oldReviewAvgs, oldReview, -1);
        newReviewAvgs = genNewReviewAvgs(newReviewAvgs, data, 1);
      } else {
        newReviewAvgs = genNewReviewAvgs(oldReviewAvgs, data, 1);
      }
      await t.update(institutesRef.doc(instituteID), {
        reviewAvgs: newReviewAvgs,
      });
    });

    console.log("Transaction success!");
  } catch (err) {
    console.log("Transaction failure:", err);
    throw err;
  }
};

// export const updateReview = async function(id, data, instituteID) {
//   data.updatedAt = firebase.firestore.FieldValue.serverTimestamp();

//   try {
//     await institutesRef
//       .doc(instituteID)
//       .collection("reviews")
//       .doc(id)
//       .update(data);
//     return true;
//   } catch (err) {
//     console.log(err.message);
//     return false;
//   }
// };

// export const deleteReview = async function(id, instituteID) {
//   const deletedAt = firebase.firestore.FieldValue.serverTimestamp();
//   const active = false;

//   try {
//     await institutesRef
//       .doc(instituteID)
//       .collection("reviews")
//       .doc(id)
//       .set({ active, deletedAt });
//     return true;
//   } catch (err) {
//     console.log(err.message);
//     return false;
//   }
// };

export const renderReviewAvgsSimple = function (reviewAvgs) {
  if (!reviewAvgs) return null;
  return (
    <Row className="show-grid" style={{ fontWeight: "bold" }}>
      {reviewAvgs.programQuality && reviewAvgs.programQuality.n > 0 ? (
        <Col sm={2} md={2}>
          {<i className="fa fa-book" aria-hidden="true"></i>}
          {`Programa: ${(
            reviewAvgs.programQuality.total / reviewAvgs.programQuality.n
          ).toFixed(2)}`}
        </Col>
      ) : null}
      {reviewAvgs.professorsQuality && reviewAvgs.professorsQuality.n > 0 ? (
        <Col sm={2} md={2}>
          {<i className="fa fa-pencil" aria-hidden="true"></i>}
          {`Ensino dos profs: ${(
            reviewAvgs.professorsQuality.total / reviewAvgs.professorsQuality.n
          ).toFixed(2)}`}
        </Col>
      ) : null}
      {reviewAvgs.professorsEthics && reviewAvgs.professorsEthics.n > 0 ? (
        <Col sm={2} md={2}>
          {<i className="fa fa-user-circle" aria-hidden="true"></i>}
          {`Ética dos profs: ${(
            reviewAvgs.professorsEthics.total / reviewAvgs.professorsEthics.n
          ).toFixed(2)}`}
        </Col>
      ) : null}
      {reviewAvgs.administrationQuality &&
      reviewAvgs.administrationQuality.n > 0 ? (
        <Col sm={2} md={2}>
          {<i className="fa fa-users" aria-hidden="true"></i>}
          {`Direção: ${(
            reviewAvgs.administrationQuality.total /
            reviewAvgs.administrationQuality.n
          ).toFixed(2)}`}
        </Col>
      ) : null}
      {reviewAvgs.facilitiesQuality && reviewAvgs.facilitiesQuality.n > 0 ? (
        <Col sm={2} md={2}>
          {<i className="fa fa-university" aria-hidden="true"></i>}
          {`Infra-estruturas: ${(
            reviewAvgs.facilitiesQuality.total / reviewAvgs.facilitiesQuality.n
          ).toFixed(2)}`}
        </Col>
      ) : null}
      {reviewAvgs.facilitiesHigiene && reviewAvgs.facilitiesHigiene.n > 0 ? (
        <Col sm={2} md={2}>
          {<i className="fa fa-bath" aria-hidden="true"></i>}
          {`Higiene: ${(
            reviewAvgs.facilitiesHigiene.total / reviewAvgs.facilitiesHigiene.n
          ).toFixed(2)}`}
        </Col>
      ) : null}
      {reviewAvgs.security && reviewAvgs.security.n > 0 ? (
        <Col sm={2} md={2}>
          {<i className="fa fa-shield" aria-hidden="true"></i>}
          {`Segurança: ${(
            reviewAvgs.security.total / reviewAvgs.security.n
          ).toFixed(2)}`}
        </Col>
      ) : null}
      {reviewAvgs.tutorQuality && reviewAvgs.tutorQuality.n > 0 ? (
        <Col sm={2} md={2}>
          {<i className="fa fa-user-circle-o" aria-hidden="true"></i>}
          {`Qualidade do tutor: ${(
            reviewAvgs.tutorQuality.total / reviewAvgs.tutorQuality.n
          ).toFixed(2)}`}
        </Col>
      ) : null}
    </Row>
  );
};

const renderAnswerAvg = function (answerAvg, label, icon = "") {
  return (
    <Col sm={2} md={2}>
      {<i className={icon} aria-hidden="true"></i>}
      {`${label}: ${(
        ((answerAvg.yes + 0.5 * answerAvg.mol) /
          (answerAvg.yes + answerAvg.no + answerAvg.mol)) *
        100
      ).toFixed(2)}%`}
    </Col>
  );
};

const renderBinaryAnswerAvg = function (answerAvg, label, icon = "") {
  return (
    <Col sm={2} md={2}>
      {<i className={icon} aria-hidden="true"></i>}
      {`${label}: ${(
        (answerAvg.yes / (answerAvg.yes + answerAvg.no)) *
        100
      ).toFixed(2)}%`}
    </Col>
  );
};

export const renderReviewAvgsComplete = function (reviewAvgs) {
  if (!reviewAvgs) return null;

  return (
    <Row className="show-grid">
      {reviewAvgs.programQuality && reviewAvgs.programQuality.n > 0 ? (
        <Col sm={2} md={2}>
          {<i className="fa fa-book" aria-hidden="true"></i>}
          {`Qualidade do programa: ${(
            reviewAvgs.programQuality.total / reviewAvgs.programQuality.n
          ).toFixed(2)}`}
        </Col>
      ) : null}
      {reviewAvgs.professorsQuality && reviewAvgs.professorsQuality.n > 0 ? (
        <Col sm={2} md={2}>
          {<i className="fa fa-pencil" aria-hidden="true"></i>}
          {`Qualidade de ensino dos profs: ${(
            reviewAvgs.professorsQuality.total / reviewAvgs.professorsQuality.n
          ).toFixed(2)}`}
        </Col>
      ) : null}
      {reviewAvgs.professorsEthics && reviewAvgs.professorsEthics.n > 0 ? (
        <Col sm={2} md={2}>
          {<i className="fa fa-user-circle" aria-hidden="true"></i>}
          {`Ética dos profs: ${(
            reviewAvgs.professorsEthics.total / reviewAvgs.professorsEthics.n
          ).toFixed(2)}`}
        </Col>
      ) : null}
      {reviewAvgs.administrationQuality &&
      reviewAvgs.administrationQuality.n > 0 ? (
        <Col sm={2} md={2}>
          {<i className="fa fa-users" aria-hidden="true"></i>}
          {`Qualidade da direção: ${(
            reviewAvgs.administrationQuality.total /
            reviewAvgs.administrationQuality.n
          ).toFixed(2)}`}
        </Col>
      ) : null}
      {reviewAvgs.facilitiesQuality && reviewAvgs.facilitiesQuality.n > 0 ? (
        <Col sm={2} md={2}>
          {<i className="fa fa-university" aria-hidden="true"></i>}
          {`Qualidade da infra-estrutura: ${(
            reviewAvgs.facilitiesQuality.total / reviewAvgs.facilitiesQuality.n
          ).toFixed(2)}`}
        </Col>
      ) : null}
      {reviewAvgs.facilitiesHigiene && reviewAvgs.facilitiesHigiene.n > 0 ? (
        <Col sm={2} md={2}>
          {<i className="fa fa-bath" aria-hidden="true"></i>}
          {`Higiene da infra-estrutura: ${(
            reviewAvgs.facilitiesHigiene.total / reviewAvgs.facilitiesHigiene.n
          ).toFixed(2)}`}
        </Col>
      ) : null}
      {reviewAvgs.security && reviewAvgs.security.n > 0 ? (
        <Col sm={2} md={2}>
          {<i className="fa fa-shield" aria-hidden="true"></i>}
          {`Segurança: ${(
            reviewAvgs.security.total / reviewAvgs.security.n
          ).toFixed(2)}`}
        </Col>
      ) : null}
      {reviewAvgs.tutorQuality && reviewAvgs.tutorQuality.n > 0 ? (
        <Col sm={2} md={2}>
          <i className="fa fa-user-circle-o" aria-hidden="true"></i>
          {`Qualidade do tutor: ${(
            reviewAvgs.tutorQuality.total / reviewAvgs.tutorQuality.n
          ).toFixed(2)}`}
        </Col>
      ) : null}
      {reviewAvgs.graduationTime && reviewAvgs.graduationTime.n > 0 ? (
        <Col sm={2} md={2}>
          {<i className="fa fa-graduation-cap" aria-hidden="true"></i>}
          {`Tempo de graduação: ${(
            reviewAvgs.graduationTime.total / reviewAvgs.graduationTime.n
          ).toFixed(2)} anos`}
        </Col>
      ) : null}
      {reviewAvgs.diplomaTime && reviewAvgs.diplomaTime.n > 0 ? (
        <Col sm={2} md={2}>
          {<i className="fa fa-file" aria-hidden="true"></i>}
          {`Tempo de entrega do diploma: ${(
            reviewAvgs.diplomaTime.total / reviewAvgs.diplomaTime.n
          ).toFixed(2)} meses`}
        </Col>
      ) : null}

      {reviewAvgs.allowsSeeingExams &&
      reviewAvgs.allowsSeeingExams.yes +
        reviewAvgs.allowsSeeingExams.no +
        reviewAvgs.allowsSeeingExams.mol >
        0
        ? renderAnswerAvg(
            reviewAvgs.allowsSeeingExams,
            "Deixam ver provas",
            "fa fa-file-text"
          )
        : null}
      {reviewAvgs.hasInternet &&
      reviewAvgs.hasInternet.yes +
        reviewAvgs.hasInternet.no +
        reviewAvgs.hasInternet.mol >
        0
        ? renderAnswerAvg(reviewAvgs.hasInternet, "Tem internet", "fa fa-globe")
        : null}
      {reviewAvgs.hasRunningWater &&
      reviewAvgs.hasRunningWater.yes +
        reviewAvgs.hasRunningWater.no +
        reviewAvgs.hasRunningWater.mol >
        0
        ? renderAnswerAvg(
            reviewAvgs.hasRunningWater,
            "Água corrente",
            "fa fa-tint"
          )
        : null}
      {reviewAvgs.hasAC &&
      reviewAvgs.hasAC.yes + reviewAvgs.hasAC.no + reviewAvgs.hasAC.mol > 0
        ? renderAnswerAvg(reviewAvgs.hasAC, "Tem AC", "fa fa-snowflake-o")
        : null}
      {reviewAvgs.hasSexualHarassment &&
      reviewAvgs.hasSexualHarassment.yes + reviewAvgs.hasSexualHarassment.no > 0
        ? renderBinaryAnswerAvg(
            reviewAvgs.hasSexualHarassment,
            "Há assédio sexual",
            "fa fa-venus-mars"
          )
        : null}
      {reviewAvgs.hasCorruption &&
      reviewAvgs.hasCorruption.yes + reviewAvgs.hasCorruption.no > 0
        ? renderBinaryAnswerAvg(
            reviewAvgs.hasCorruption,
            "Há corrupção",
            "fa fa-user-secret"
          )
        : null}
      {reviewAvgs.hasInternship &&
      reviewAvgs.hasInternship.yes + reviewAvgs.hasInternship.no > 0
        ? renderBinaryAnswerAvg(
            reviewAvgs.hasInternship,
            "Oferecem estágio",
            "fa fa-briefcase"
          )
        : null}
      {reviewAvgs.endorsement &&
      reviewAvgs.endorsement.yes + reviewAvgs.endorsement.no > 0
        ? renderBinaryAnswerAvg(
            reviewAvgs.endorsement,
            "Aconselhável",
            "fa fa-thumbs-up"
          )
        : null}
    </Row>
  );
};
